import React, { useState, useEffect } from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';

export default function SimpleCheckbox({
  name,
  label,
  labelClassName,
  labelFirst = false,
  inOneLine = false,
  className,
  error,
  touched,
  checked,
  onChange,
  disabled,
  ...props
}) {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleClick = () => {
    if (!disabled) {
      onChange?.();
    }
  };

  return (
    <>
      <div
        className={`cursor-pointer my-2 ${
          inOneLine ? 'flex items-center justify-start gap-2' : ''
        } ${className || ''}`}
        onClick={handleClick}>
        {label && labelFirst && (
          <span
            className={`text-lg font-bold ${labelClassName || ''}`}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}
        <input
          hidden
          name={name}
          id={name}
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
        <span className="flex items-center justify-center w-[26px] h-[26px] rounded-lg bg-gray-100 shrink-0">
          {isChecked && <CheckIcon color="#545454" width={22} />}
        </span>
        {label && !labelFirst && (
          <span
            className={`text-base font-normal ${labelClassName || ''}`}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}
      </div>
      {error && touched && (
        <p className="text text-red-500" data-testid="error-text">
          {error}
        </p>
      )}
    </>
  );
}
